module.exports = __webpack_public_path__ + "img/upload.a865d852.svg";